module.exports = {"schedule":{"title":"Planning","now_playing":"En cours","empty":{"title":"Aucun résultat","detail":"Aucun élément à venir à afficher"}}}